import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';

import { SharedModule } from 'src/app/shared/shared.module';
import { LoginComponent } from './components';
import { AuthCodeFlowConfig } from './auth.config';

@NgModule({
  declarations: [LoginComponent, ForbiddenComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [AuthCodeFlowConfig.issuer!],
        sendAccessToken: true,
      },
    }),
  ],
  exports: [LoginComponent, ForbiddenComponent],
})
export class AuthModule {}
